import { cn } from 'cn';
import { memo, type ReactNode } from 'react';

import { EmptyStateIllustration } from '~/assets/illustrations';

import { ParagraphWrapper } from '~/ui/atoms/ParagraphWrapper';

type P = {
  CallToAction?: ReactNode;
  heading?: string;
  hint: string | string[];
  Illustration?: ReactNode | undefined;
} & ComponentStyling;

export const EmptyState = memo<P>(
  ({
    CallToAction = null,
    Illustration = <EmptyStateIllustration />,
    className,
    heading,
    hint,
    style,
  }) => (
    <div
      className={cn(
        'mx-auto flex size-full max-h-96 max-w-lg flex-col justify-center gap-y-2 p-4 text-center',
        className,
      )}
      style={style}
    >
      {Illustration}
      {heading ? (
        <h2 className="text-tigaText-lightest text-xl">{heading}</h2>
      ) : null}
      <div className="text-tigaText-lighter text-sm">
        {Array.isArray(hint) ? (
          <ParagraphWrapper paragraphs={hint} wrapIn="div" />
        ) : (
          hint
        )}
      </div>
      {CallToAction}
    </div>
  ),
);
